import { marqueeText } from "../data/servicesData";

export const Marquee = () => (
  <section
    data-testid="brand-marquee"
    className="bg-[#FDFBF7] border-y border-[#111111]/10 py-6 md:py-9 overflow-hidden"
    aria-label="Picaso Studios"
  >
    <div className="flex w-max marquee-track">
      {[0, 1].map((i) => (
        <div key={i} className="flex items-center shrink-0">
          {Array.from({ length: 5 }).map((_, j) => (
            <span key={j} className="flex items-center shrink-0">
              <span className="font-serif italic text-xl md:text-3xl lg:text-4xl font-light text-obsidian/85 px-6 md:px-8 whitespace-nowrap">
                {marqueeText}
              </span>
              <span className="text-champagne text-xl md:text-3xl">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);

export default Marquee;
